import React from 'react';
import './PricingSection.css';

const PricingSection: React.FC = () => {
  const pricingPlans = [
    {
      name: "Zajęcia Grupowe",
      price: "65",
      period: "PLN/60 minut ",
      description: "Zajęcia grupowe dostosowane do poziomu ucznia",
      features: [
        "Zajęcia grupowe (3-6 osób)",
        "Różne poziomy zaawansowania",
        "Szkoła podstawowa",
        "Szkoła średnia",
        "Przygotowanie do egzaminów",
        "Materiały dydaktyczne w cenie",
        "Wsparcie między zajęciami"
      ],
      highlighted: false,
      buttonText: "Wybierz grupowe"
    },
    {
      name: "Zajęcia Indywidualne",
      price: "150",
      period: "PLN/60 minut",
      description: "Zajęcia indywidualne - przygotowanie do matury i egzaminu ósmoklasisty",
      features: [
        "Zajęcia 1:1 z nauczycielem",
        "Przygotowanie do matury",
        "Przygotowanie do egzaminu ósmoklasisty",
        "Elastyczne terminy",
        "Spersonalizowany program nauki",
        "Intensywne wsparcie",
        "Monitoring postępów"
      ],
      highlighted: true,
      buttonText: "Wybierz Bestseler"
    },
    {
      name: "Indywidualne Potrzeby",
//       price: "od 150",
//       period: "PLN/60 minut",
      description: "Specjalna opieka, konkursy matematyczne i intensywna nauka - daj znać w formularzu (Dodatkowe informacje) ",
      features: [
        "Przygotowanie do konkursów",
        "Olimpiady matematyczne",
        "Specjalna opieka pedagogiczna",
        "Kursy wakacyjne",
        "Bardzo intensywny okres przygotowawczy",
        "Konsultacje rodzinne",

      ],
      highlighted: false,
      buttonText: "Skontaktuj się"
    }
  ];

  const handlePlanSelect = (planName: string) => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="section-header">
          <h2>Cennik Naszych Zajęć</h2>
          <p>Wybierz pakiet dostosowany do Twoich potrzeb i budżetu</p>
        </div>

        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.highlighted ? 'highlighted' : ''}`}>
              {plan.highlighted && <div className="popular-badge">Najpopularniejszy</div>}

              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>

              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="checkmark">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                className={`plan-button ${plan.highlighted ? 'highlighted' : ''}`}
                onClick={() => handlePlanSelect(plan.name)}
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PricingSection;
